// src/constants/errors.js
export const ERROR_CODES = {
    GMAIL_TOKEN_EXPIRED: "GMAIL_TOKEN_EXPIRED",
    MISSING_GMAIL_TOKENS: "MISSING_GMAIL_TOKENS",
    OAUTH_TOKEN_REVOKED: "OAUTH_TOKEN_REVOKED",
    OAUTH_NOT_CONFIGURED: "OAUTH_NOT_CONFIGURED",
    GMAIL_API_ERROR: "GMAIL_API_ERROR",
    INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    NOT_FOUND: "NOT_FOUND",
    EMAIL_NOT_VERIFIED: "EMAIL_NOT_VERIFIED",
    NO_GMAIL_CREDENTIALS: "NO_GMAIL_CREDENTIALS",
    INFLUENCER_EMAIL_NOT_FOUND: "INFLUENCER_EMAIL_NOT_FOUND",
    NO_NEW_EMAILS_FOUND: "NO_NEW_EMAILS_FOUND",
    MAX_NEW_EMAILS_ERROR: "MAX_NEW_EMAILS_ERROR",
    FAILED_TO_INITIALIZE_GMAIL_SERVICE: "FAILED_TO_INITIALIZE_GMAIL_SERVICE",
    INVALID_INPUT: "INVALID_INPUT",
    DATABASE_ERROR: "DATABASE_ERROR",
    GMAIL_AUTH_FAILED: "GMAIL_AUTH_FAILED",
    NO_MATCHING_CREDENTIALS: "NO_MATCHING_CREDENTIALS",
    FAILED_TO_SAVE_EMAILS: "FAILED_TO_SAVE_EMAILS",
    FAILED_TO_FETCH_EMAILS: "FAILED_TO_FETCH_EMAILS",
    FAILED_TO_GENERATE_SUMMARY: "FAILED_TO_GENERATE_SUMMARY",
    FAILED_TO_SAVE_SUMMARY: "FAILED_TO_SAVE_SUMMARY",
    FAILED_TO_FETCH_OPERATIONAL_SUMMARY: "FAILED_TO_FETCH_OPERATIONAL_SUMMARY",
    USER_NOT_FOUND: "USER_NOT_FOUND",
    INFLUENCER_NOT_FOUND: "INFLUENCER_NOT_FOUND",
    NOT_INFLUENCER_OWNER: "NOT_INFLUENCER_OWNER",
    USER_NOT_AUTHENTICATED: "USER_NOT_AUTHENTICATED",
    NETWORK_ERROR: "NETWORK_ERROR",
    REQUEST_ERROR: "REQUEST_ERROR",
    MULTIPLE_ERRORS: "MULTIPLE_ERRORS", 
    CRITICAL_POLLER_FAILURE: "CRITICAL_POLLER_FAILURE",
    // Add other error codes as needed
};

export const ERROR_MESSAGES = {
    [ERROR_CODES.GMAIL_TOKEN_EXPIRED]: "Your Gmail token has expired. Please reconnect.",
    [ERROR_CODES.MISSING_GMAIL_TOKENS]: "Your Gmail connection is incomplete. Please reconnect.",
    [ERROR_CODES.GMAIL_API_ERROR]: "A Gmail API error occurred.",
    [ERROR_CODES.INTERNAL_SERVER_ERROR]: "An internal server error occurred. Please try again later.",
    [ERROR_CODES.UNAUTHORIZED]: "You are not authorized to perform this action.",
    [ERROR_CODES.FORBIDDEN]: "You do not have permission to access this resource.",
    [ERROR_CODES.NOT_FOUND]: "The requested resource was not found.",
    [ERROR_CODES.NO_GMAIL_CREDENTIALS]: "No Gmail credentials found. Please connect your Gmail account.",
    [ERROR_CODES.INFLUENCER_EMAIL_NOT_FOUND]: "The influencer does not have an email address associated with their record.",
    [ERROR_CODES.NO_NEW_EMAILS_FOUND]: "No new emails found.",
    [ERROR_CODES.MAX_NEW_EMAILS_ERROR]: "Reached limit of new messages. Please go to the Relationship menu and generate a new AI summary.",
    [ERROR_CODES.FAILED_TO_INITIALIZE_GMAIL_SERVICE]: "Failed to initialize the Gmail service. Please reconnect",
    [ERROR_CODES.INVALID_INPUT]: "Invalid input provided.",
    [ERROR_CODES.DATABASE_ERROR]: "A database error occurred. Please try again later.",
    [ERROR_CODES.GMAIL_AUTH_FAILED]: "Gmail authentication failed.",
    [ERROR_CODES.NO_MATCHING_CREDENTIALS]: "No matching credentials found.",
    [ERROR_CODES.FAILED_TO_SAVE_EMAILS]: "Failed to save emails.",
    [ERROR_CODES.FAILED_TO_FETCH_EMAILS]: "Failed to fetch emails.",
    [ERROR_CODES.FAILED_TO_GENERATE_SUMMARY]: "Failed to generate the email summary.",
    [ERROR_CODES.FAILED_TO_SAVE_SUMMARY]: "Failed to save the email summary.",
    [ERROR_CODES.FAILED_TO_FETCH_OPERATIONAL_SUMMARY]: "Failed to fetch the operational summary.",
    [ERROR_CODES.USER_NOT_FOUND]: "User not found.",
    [ERROR_CODES.INFLUENCER_NOT_FOUND]: "Influencer not found.",
    [ERROR_CODES.NOT_INFLUENCER_OWNER]: "You do not have permission to access this influencer's data.",
    [ERROR_CODES.USER_NOT_AUTHENTICATED]: "User not authenticated. Please log in.",
    [ERROR_CODES.NETWORK_ERROR]: "Could not connect to the server. Please check your network connection and try again.",
    [ERROR_CODES.REQUEST_ERROR]: "An unexpected error occurred while setting up the request.",
    [ERROR_CODES.MULTIPLE_ERRORS]: "Multiple validation errors occurred.",
    // Add other error messages as needed
};